import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { accessIncludes } from '../../data/content';
export function WhyPay() {
  return <section className="bg-paper-50 px-5 py-14 sm:px-8 sm:py-20" data-id="element-339" data-mp="3hndli93x5dkn">
      <div className="mx-auto max-w-4xl" data-id="element-340" data-mp="3mnri8v02l13d">
        <SectionHeading tone="light" title="Why Pay for Another Resource?" data-id="element-341" data-mp="3mot4zwqg7c0x" />

        <div className="mx-auto mt-6 max-w-2xl space-y-2 text-center text-[15px] leading-relaxed text-ink-600 sm:text-base" data-id="element-342" data-mp="3rl9v2wh7k0gn">
          <p data-id="element-343" data-mp="e72q1pmvo4u">Because the problem isn’t that medical information doesn’t exist.</p>
          <p className="font-bold text-ink-900" data-id="element-344" data-mp="581gkoik58w0">It’s that the information is scattered.</p>
          <p data-id="element-345" data-mp="97abvxt8xeto">One guideline says one thing. Another paper adds context.</p>
          <p data-id="element-346" data-mp="e7yc9a3d780k">A laboratory result creates another question.</p>
          <p data-id="element-347" data-mp="e5bvqkyhxi67">A patient presents with a special circumstance.</p>
          <p data-id="element-348" data-mp="j7ayptqbqd2m">
            And suddenly a decision that should feel organized becomes another research project.
          </p>
          <p className="font-semibold text-ink-900" data-id="element-349" data-mp="5i8eoi3d5o9w">
            The Master System of TRT™ was created to give you a structured place to start.
          </p>
        </div>

        <div className="mt-8 grid gap-2 sm:grid-cols-3" data-id="element-350" data-mp="3smobb0v5bvj8">
          {['Less searching.', 'More structure.', 'A clearer decision process.'].map(line => <p key={line} className="rounded-xl bg-ink-900 px-4 py-4 text-center font-display text-base font-bold uppercase leading-tight tracking-[0.08em] text-teal-300 sm:text-lg" data-id="element-351" data-mp="o7exs682khw8">
              {line}
            </p>)}
        </div>

        <h3 className="mt-14 text-center font-display text-2xl font-bold uppercase tracking-tight text-ink-900 sm:text-3xl" data-id="element-352" data-mp="fcrzdu0tp5th">
          Your Access Includes
        </h3>

        <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-353" data-mp="17wyu4h6yzxnd">
          {accessIncludes.map(item => <li key={item.title} className="flex gap-3 rounded-2xl border border-paper-200 bg-white p-4" data-id="element-354" data-mp="1334b7fz6vmpc">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal-500" data-id="element-355" data-mp="1qzr8rzvgziup">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-356" data-mp="1d9fdxt7i35zv" />
              </span>
              <div className="min-w-0" data-id="element-357" data-mp="1h9fvvntt5zbo">
                <p className="text-[15px] font-extrabold leading-snug text-ink-900" data-id="element-358" data-mp="1h84pdg8zadgv">{item.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-ink-600" data-id="element-359" data-mp="13cj4nl9s2fu9">{item.body}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-12 rounded-2xl border border-ink-900/10 bg-white p-6 sm:p-8" data-id="element-360" data-mp="uajm2oj473p7">
          <h3 className="text-center font-display text-xl font-bold uppercase leading-tight tracking-tight text-ink-900 sm:text-2xl" data-id="element-361" data-mp="yatqhwr9dm1y">
            You don’t need another 20-hour course.
          </h3>
          <p className="mt-3 text-center text-[15px] leading-relaxed text-ink-600 sm:text-base" data-id="element-362" data-mp="2spwdnnsu4s1p">
            You need something you can actually open when you need it. The Master System of TRT™ is
            designed as a practical reference:
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-2 gap-y-2" data-id="element-363" data-mp="cycpibuo8rv7">
            {['Question', 'Protocol', 'Decision', 'Follow-up'].map((step, i, arr) => <React.Fragment key={step} data-id="element-364" data-mp="lzkokw50hwqc" data-mpi={i}>
                <span className="rounded-lg bg-teal-50 px-3 py-2 text-[13px] font-bold uppercase tracking-[0.08em] text-teal-700 sm:text-sm" data-id="element-365" data-mp="10q0ciiotbis7">
                  {step}
                </span>
                {i < arr.length - 1 ? <span className="text-teal-500" aria-hidden="true" data-id="element-366" data-mp="19pnbyyxzeeim">
                    →
                  </span> : null}
              </React.Fragment>)}
          </div>
          <p className="mt-5 text-center text-[15px] leading-relaxed text-ink-600 sm:text-base" data-id="element-367" data-mp="3bj4i1y6gr7b9">
            Instead of spending your consultation time searching through disconnected resources, you
            have a structured system built around the TRT workflow.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-368" data-mp="3cygy8k1ujnwh">
          <CtaButton label="Access the Complete System for $27" subLabel="One-Time Payment · Lifetime Access" data-id="element-369" data-mp="3d1bfy3th6um7" />
        </div>
      </div>
    </section>;
}